import ACTIONS from './actions';

const defaultState = {
    calendarHeaderEnabled: false,
    designerHeader: { enabled: false }
};

const nav = (state = defaultState, action) => {
    switch (action.type) {
        case ACTIONS.CALENDAR_HEADER_TOGGLE:
            return {
                ...state,
                calendarHeaderEnabled: action.enabled
            };
        case ACTIONS.DESIGNER_HEADER_TOGGLE:
            return {
                ...state,
                designerHeader: {
                    enabled: action.enabled,
                    config: action.config
                }
            };
        case ACTIONS.NAV_SET_PATH:
            return {
                ...state,
                path: action.path
            };
        default:
            return state;
    }
};

export default nav;



// WEBPACK FOOTER //
// ./src/state/reducer/nav/reducer.js